import { BlocksIconProp65 } from 'blocks-nextjs/blocks-web-components/components/icon/icons/prop65';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconProp65 = createComponent({
  react: React,
  tagName: 'cat-icon-prop65',
  elementClass: BlocksIconProp65
});
